import React from 'react';
import classes from './ResourceConfig.module.scss';
import { Stack } from '@mui/material';
import Typography from 'new/elements/Typography';

interface ResourceConfigProps {
  label: string;
  value: string;
}

export const ResourceConfig = (props: ResourceConfigProps) => {
  const { label, value } = props;
  return (
    <Stack className={classes.container}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
    </Stack>
  );
};
